import { refresh } from "../utils/refresh";
import { history } from "../store";
import { apigClientFactory } from "../apiGateway/apigClientFactory";
import { ACTION_NAMES } from "../utils/actionConstants";

const unloadStaticContent = (language) => ({
  type: ACTION_NAMES.STATIC_CONTENT.UNLOAD_STATIC_CONTENT,
  payload: null,
});

const requestStaticContent = (language) => ({
  type: ACTION_NAMES.STATIC_CONTENT.REQUEST_STATIC_CONTENT,
  payload: language,
});

const receiveStaticContent = (static_content) => ({
  type: ACTION_NAMES.STATIC_CONTENT.RECEIVE_STATIC_CONTENT,
  payload: static_content,
});

const getFractionalMode = (callback) => {
  const myRequest = new Request(process.env.REACT_APP_FRACTIONAL_LOCATION)

  fetch(myRequest, {
      method: 'GET',
      mode: 'cors',
      headers: {
          'content-type': 'application/json',
          'Accept': 'application/json'
      }
  })
  .then(response => {
      return response.json()
  })
  .then(json => {
      console.log("Got the json", json)
      callback(json.enable)
  })
  .catch((error) => {
      console.log("Error fractional mode")
      callback(false)
  })
}

export const actions = {
  unload: () => (dispatch, getState) => {
    dispatch(unloadStaticContent());
  },

  load: (language = "en-US") => async (dispatch, getState) => {
    const state = getState();

    try {
      await refresh(state.auth.auth);
    } catch (error) {
      console.log("Refresh Error: " + error);
      history.push("/logout");
      return;
    }

    var params = {
      Authorization: `Bearer ${state.auth.auth.secret}`,
      language, // employee id
    };
    var body = {};
    var additionalParams = {};

    var apigClient;
    if (process.env.REACT_APP_API_GATEWAY) {
      apigClient = apigClientFactory.newClient({
        invokeUrl: process.env.REACT_APP_API_GATEWAY,
      });
    } else {
      apigClient = apigClientFactory.newClient();
    }

    dispatch(requestStaticContent(language));
    apigClient
      .staticContentLanguageGet(params, body, additionalParams)
      .then((result) => {
        console.log("success getting static data");
        getFractionalMode(fractional_mode => {
          result.data.fractional_mode = fractional_mode

          // Let's load the app with the language set by the employee
          dispatch(receiveStaticContent(result.data));
        })
      })
      .catch((error) => {
        console.log(error);
        console.log("Load Static content Data failed!!");
        //TODO handle error
      });
  },
};
